var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":("cl-slide-" + _vm.direction)}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.computedIn),expression:"computedIn"}],class:( _obj = {
      'cl-slide': true
    }, _obj[("cl-slide-" + _vm.direction)] = true, _obj )},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }